import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-style paragraph-style" }

import {exec, init} from 'pell';
import {onMounted, ref, watch} from 'vue';
import 'pell/dist/pell.min.css';
import {htmlIconFormatBold, htmlIconFormatListOrdered, htmlIconFormatListUnordered} from "../Icon/icons";

interface Props {
  placeholder: string;
  testId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextFieldFormat',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    testId: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const model = _useModel<string>(__props, "modelValue");
const editorContainer = ref<HTMLElement|null>(null);

onMounted(() => {
  const editor = init({
    element: editorContainer.value!,
    onChange(html: string): void {
      model.value = html;
    },
    defaultParagraphSeparator: 'p',
    actions: [
      {icon: htmlIconFormatBold, result: () => exec('bold')},
      {icon: htmlIconFormatListUnordered, result: () => exec('insertUnorderedList')},
      {icon: htmlIconFormatListOrdered, result: () => exec('insertOrderedList')},
    ],
  });
  editor.content.innerHTML = model.value!;
  if (props.testId) {
    editor.content.setAttribute('data-testid', props.testId);
  }
});

watch(model, (newContent?: string): void => {
  const pellContent = editorContainer.value!.querySelector('.pell-content')!;
  if (pellContent.innerHTML !== newContent!) {
    pellContent.innerHTML = newContent!; // this resets cursor to start
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "editorContainer",
      ref: editorContainer
    }, null, 512 /* NEED_PATCH */)
  ]))
}
}

})